export default __webpack_public_path__ + "static/media/leftimgForm2.d95968e9.svg";